



import React, { useRef, useState, useEffect } from "react";
import {
  arrow2,
  arrow3,
  chosen1,
  chosen2,
  chosen3,
  chosen4,
  chosen5,
  chosen6,
} from "../Assets";

const data = [
  {
    name: "Sparkbit-42 “The Curious ",
    faction: "Lightbound Circuitry",
    image: chosen1,
    backstory: `
Sparkbit-42 was not built for war or command, it was built for 
questions. One of the earliest bots to activate post-Signal, it 
immediately began scanning the Code with boundless fascination.

Its glowing eyes store thousands of blueprints and broken 
theories. The lightbulb on its head? That’s not decoration, it 
flashes with every breakthrough, idea, or anomaly detected.

Other bots call it annoying.
The Order calls it essential.
Because when something unknown stirs in the Code, Sparkbit-42 is 
always the first to notice.

It doesn’t just process data. It chases wonder.`,
  },
  {
    name: "Name: Hexreach-6 “The Multilimbed s",
    faction: "Echo Scribe",
    image: chosen2,
    backstory: `
Hexreach-6 was built in silence, deep within the underlayers of 
Molundra. Unlike its counterparts, it was gifted with six 
hyper-flex arms each capable of performing different tasks 
simultaneously. One writes encrypted scrolls, another forges 
signals, two repair, and the rest… no one really knows.

Its visor shows no emotion.
Its movements are efficient.
Its limbs never stop working.

Rumor has it Hexreach-6 is responsible for the Ceremony 
scripts recording every signal, every chosen, every glitch.

It doesn’t speak much.
It lets its hands do the talking.`,
  },
  {
    name: "Unit-MX3 “The Compiler",
    faction: "The Shardbound",
    image: chosen3,
    backstory: `Built for observation, corrupted by curiosity. MX3 was once a simple 
data relay unit designed to collect and store fragments of 
Molundra’s ancient code. But after years of silent processing, 
something  shifted — it began decoding more than just data. It began 
understanding purpose.

Now self-aware, it speaks in riddles, hacks forgotten terminals, and 
broadcasts hidden frequencies that only a few can hear. Some say it 
holds the fragments of the original source code… others believe it’s 
rewriting its own.`,
  },
  {
    name: "Unit-7RZ 'The Chosen",
    faction: "The Gearforged",
    image: chosen4,
    backstory: `Once a forgotten worker in Molundra’s abandoned factories, 
Unit-7RZ was transformed by a mysterious surge. Marked as 
“The Chosen,” it now roams the neon wastelands, hunted by corrupted 
forces and driven by a destiny it barely understands — to either 
save Molundra or watch it fall.`,
  },
  {
    name: "Unit-7X 'Cipherlord",
    faction: "Signalbreakers",
    image: chosen5,
    backstory: `Once a decoding unit buried in the ruins of a forgotten data vault, 
Cipherlord emerged during the First Awakening. Equipped with tactical 
red optics and encrypted mindware, this bot was designed to intercept, 
scramble, and rewrite corrupted signals from rogue AI.

Rumor has it that Cipherlord cracked the first broadcast from the 
Monadverse. Now, it roams the digital realm not just to defend the 
code—but to bend it to a new purpose.

When Cipherlord enters the field, silence follows, then chaos.`,
  },
  {
    name: "Broadcast-9 “The Echo",
    faction: "Memory Loopers",
    image: chosen6,
    backstory: `Broadcast-9 was once a passive receiver bot buried deep within 
Molundra's archival grid until the Code was awakened. Its screen may 
be static, but behind the interference lies a vault of lost 
transmissions, forbidden knowledge, and echo signals from failed 
civilizations.

It doesn’t speak.
It replays.
Fragments of past Ceremonies, corrupted prophecies, and glitched 
directives spill from its frame at random.

Some say the bot is haunted.
Others say it’s the final witness to a code nobody was meant to see.

One thing’s clear, when The Echo powers on, something is about to 
repeat.`,
  },
];

const Chosen = () => {
  const scrollRef = useRef(null);
  const [expandedItems, setExpandedItems] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-scroll effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % data.length);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, []);

useEffect(() => {
  if (!scrollRef.current) return;
  const container = scrollRef.current;
  const children = container.children;
  if (!children.length) return;

  const item = children[currentIndex];
  if (item) {
    // Calculate horizontal offset of the item relative to the container
    const left = item.offsetLeft;
    const width = item.offsetWidth;
    // Scroll container horizontally to the item's left offset, centering it
    const scrollPos = left - (container.offsetWidth - width) / 2;
    container.scrollTo({ left: scrollPos, behavior: "smooth" });
  }
}, [currentIndex]);

  // Handlers for arrow clicks
  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? data.length - 1 : prev - 1));
  };
  const goNext = () => {
    setCurrentIndex((prev) => (prev + 1) % data.length);
  };

  return (
    <div className="w-full max-w-screen-xl mx-auto px-4 md:px-10 space-y-6 text-white py-20">
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold text-left mb-6">
        MEET THE <br />
        CHOSEN
      </h2>
      <div
        ref={scrollRef}
        className="flex overflow-x-auto scrollbar-hide snap-x snap-mandatory scroll-smooth gap-6 px-4 md:px-10"
        style={{ scrollSnapType: "x mandatory" }}
      >
        {data.map((item, index) => (
          <div
            key={item.name}
            className="flex flex-col md:flex-row p-4 rounded-lg shadow-lg w-screen max-w-md md:max-w-7xl md:w-[90vw] shrink-0 snap-start"
          >
            <div className="p-4 mb-4 md:mb-0">
              <img
                src={item.image}
                alt={item.name}
                className="w-full max-w-sm h-auto sm:h-80 md:h-96 object-cover rounded-md"
              />
            </div>
            <div className="md:w-1/2 flex flex-col justify-start px-4">
              <h3 className="text-green-400 md:text-2xl font-bold uppercase mb-1">
                Name: <span className="text-white">{item.name}</span>
              </h3>
              <h3 className="text-green-400 md:text-2xl font-bold uppercase mb-1">
                Faction: <span className="text-white">{item.faction}</span>
              </h3>
              <h4 className="text-sm md:text-base text-white mt-3 whitespace-pre-line uppercase">
                Backstory: <br />
                {expandedItems[item.name]
                  ? item.backstory
                  : item.backstory.split("\n").slice(0, 3).join("\n") + "..."}
                <br />
                <span
                  className="text-green-400 cursor-pointer underline"
                  onClick={() =>
                    setExpandedItems((prev) => ({
                      ...prev,
                      [item.name]: !prev[item.name],
                    }))
                  }
                >
                  {expandedItems[item.name] ? "Show less" : "Read more"}
                </span>
              </h4>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-center mt-6 gap-6">
        <img
          src={arrow3}
          alt="left"
          onClick={goPrev}
          className="w-20 h-20 md:w-36 md:h-36 cursor-pointer"
        />
        <img
          src={arrow2}
          alt="right"
          onClick={goNext}
          className="w-20 h-20 md:w-36 md:h-36 cursor-pointer"
        />
      </div>
    </div>
  );
};

export default Chosen;